import PagesImages from './PagesImages';
import PagesVideos from './PagesVideos';
import PagesCustomFonts from './PagesCustomFonts';
import PagesTracking from './PagesTracking';
import PagesCustomization from './PagesCustomization';
import PagesOther from './PagesOther';

export { PagesImages, PagesVideos, PagesTracking, PagesCustomization, PagesOther, PagesCustomFonts };



// WEBPACK FOOTER //
// ./src/components/assets/index.js